import ImageDisplay from './ImageDisplay'
export default ImageDisplay